/**
 * Tipos frontend para criterios de inclusión residencial — V1.6
 *
 * Mirrors de las interfaces del backend (project.entity.ts + building-residential-criteria.dto.ts).
 */

// ─── Criterios ────────────────────────────────────────────────────────────────

export interface BuildingResidentialCriteria {
  includeUnclassifiedAsResidential: boolean;
  includeResidential:               boolean;
  includeMixed:                     boolean;
  excludeNonResidential:            boolean;

  excludeByFootprintArea:         boolean;
  maxResidentialFootprintAreaM2:  number | null;

  excludeByBuiltArea:             boolean;
  maxResidentialBuiltAreaM2:      number | null;

  excludeUnassociated:            boolean;
  excludeWithoutEstimatedMass:    boolean;

  updatedAt:  string;
  updatedBy:  string | null;
}

export const DEFAULT_RESIDENTIAL_CRITERIA: Omit<BuildingResidentialCriteria, 'updatedAt' | 'updatedBy'> = {
  includeUnclassifiedAsResidential: true,
  includeResidential:               true,
  includeMixed:                     true,
  excludeNonResidential:            true,
  excludeByFootprintArea:           false,
  maxResidentialFootprintAreaM2:    null,
  excludeByBuiltArea:               false,
  maxResidentialBuiltAreaM2:        null,
  excludeUnassociated:              false,
  excludeWithoutEstimatedMass:      false,
};

// ─── API responses ────────────────────────────────────────────────────────────

export interface ResidentialCriteriaResponse {
  projectId:  string;
  criteria:   BuildingResidentialCriteria;
  isDefault:  boolean;
}

export interface ResidentialCriteriaBreakdownItem {
  reason: string;
  count:  number;
  label:  string;
}

export interface ResidentialCriteriaPreview {
  projectId:         string;
  criteria:          BuildingResidentialCriteria;
  totalBuildings:    number;
  autoEligible:      number;
  autoExcluded:      number;
  manualIncluded:    number;
  manualExcluded:    number;
  effectiveEligible: number;
  breakdown:         ResidentialCriteriaBreakdownItem[];
}

// ─── PATCH DTO (subset enviable) ──────────────────────────────────────────────

export type PatchResidentialCriteriaDto = Partial<Omit<BuildingResidentialCriteria, 'updatedAt' | 'updatedBy'>>;
